import React from "react";
export const MagnifyingGlassIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.3125 1.75C5.13787 1.75 3.375 3.51288 3.375 5.6875C3.375 6.77502 3.81489 7.75836 4.52826 8.47173C5.24163 9.1851 6.22498 9.625 7.3125 9.625C9.48712 9.625 11.25 7.86212 11.25 5.6875C11.25 3.51288 9.48712 1.75 7.3125 1.75ZM1.875 5.6875C1.875 2.68445 4.30945 0.25 7.3125 0.25C10.3155 0.25 12.75 2.68445 12.75 5.6875C12.75 8.69055 10.3155 11.125 7.3125 11.125C6.08174 11.125 4.94568 10.7154 4.03451 10.0261L1.53033 12.5303L0.469666 11.4697L2.97385 8.96548C2.28457 8.05432 1.875 6.91826 1.875 5.6875Z"
      fill="#161C22"
    />
  </svg>
);
